export enum TDStorePage {
  MERCHANT_REQUEST = 'Merchant Request',
  MERCHANT_EDIT = 'Merchant List',
  STORE_REQUEST = 'Store Request',
  STORE_EDIT = 'Store List',
  STORE_EDIT_ORDER_SCHEDULE = 'Store Edit Order Schedule',
  STORE_EDIT_PRE_ORDER_HUB_SCHEDULE = 'Store Edit Pre Order Hub Schedule'
}

export enum TDStoreEnum {
  REPLENISH = 'REPLENISH',
  CHILLED = 'CHILLED',
  LIFESTYLE = 'LIFESTYLE',
  STORE_ITEM = 'STORE_ITEM',
  FROZEN = 'FROZEN'
}

export enum TDStoreTypeEnum {
  REPLENISH = 'Replenish',
  CHILLED = 'Chilled',
  LIFESTYLE = 'Lifestyle',
  STORE_ITEM = 'Store Item',
  FROZEN = 'Frozen'
}

export enum ShelfPages {
  SHELF_REQUEST = 'Shelf Request',
  SHELF_REQUEST_FIX_ASSET = 'Shelf Request FixAsset',
  SHELF_REQUEST_INVENTORY = 'Shelf Request Inventory',
  SHELF_EDIT = 'Shelf List',
  SHELF_FIX_ASSET_EDIT = 'Shelf FixAsset List',
  SHELF_INVENTORY_EDIT = 'Shelf Inventory List'
}
